/* eslint-disable no-lone-blocks */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {ErrorMessage, Field, Form, Formik, useFormik} from 'formik'
import {useDispatch, useSelector} from 'react-redux'
import ToggleSwitch from 'react-bootstrap/Form'
import {KTSVG} from '../../../../../_metronic/helpers'
import {fetchAsyncChangeEmail, fetchAsyncChangePassword} from '../../../../Redux/FrontEnd'
import {
  MessageNotification,
  emailFormValidationSchema,
  networkChangeValidationSchema,
  passwordFormValidationSchema,
} from '../../../../Utils/_helpers/ValidationSchema'
import {getUserData} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {
  GetOwnersMessageNotificationSetting,
  GetOwnersReportSetting,
  UpdateOwnersMessageNotificationSetting,
} from '../Billing/BillingSlice/BillingSlice'
import MessageNotificationModule from './MessageNotificationModule'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {
  getAllUserDetails,
  updateOwnersGlobalSetting,
  fetchAsyncUserDetails,
} from '../Overview/OverviewSlice/UserDetailsSlice'
import {
  useUpdate2FASettingMutation,
  useUpdateOwnerStatusPageSubscribeMutation,
} from '../../../../../services/cellcast'
import Spinner from '../../../../Components/Spinner'
import {toast} from 'react-toastify'
import {isArray} from 'lodash'
import clsx from 'clsx'
import SoundNotification from './SoundNotificationModule'
import OptOutFraudKeyword from './OptOutFraudKeyword'
import ReportsNotificationModule from './ReportsNotificationModule'

const FrontendSigninMethod = () => {
  const globalSettingsTypes = {
    BULK_SMS_REPLY_STOP_OUTPUT: 'bulkSMSReplyStopOutout',
    BULK_MMS_REPLY_STOP_OUTPUT: 'bulkMMSReplyStopOutout',
    QUICK_SMS_REPLY_STOP_OUTPUT: 'quickSMSReplyStopOutout',
    QUICK_MMS_REPLY_STOP_OUTPUT: 'quickMMSReplyStopOutout',
    QUICK_MESSAGE_TO_UNSUB_CONTACT: 'sendQuickMessageToUnsubContact',
    BULK_MESSAGE_TO_UNSUB_CONTACT: 'sendBulkMessageToUnsubContact',
  }
  const updateEmailData = useSelector((state: any) => state?.userDetails?.userDetails?.data?.user)
  const globalSettingData = useSelector((state: any) => getAllUserDetails(state))?.globalSetting
  const [emailUpdateData] = useState<any>({
    newEmail: '',
    confirmPassword: '',
  })
  const [passwordUpdateData] = useState<any>({
    currentPassword: '',
    newPassword: '',
    passwordConfirmation: '',
  })

  const [showEmailForm, setShowEmailForm] = useState<boolean>(false)
  const [showPasswordForm, setPasswordForm] = useState<boolean>(false)
  const [globalSettings, setGlobalSettings] = useState<string[]>([])
  const [statusPage, setStatusPage] = useState<string[]>([])
  const messageModuleData = useSelector((state: any) => state?.PurchaseHistory?.messageNotification)
  const reportsModuleData = useSelector((state: any) => state?.PurchaseHistory?.reportsNotification)
  const [messageModule, setMessageModule] = useState<any>({
    messageRepliesEmail: messageModuleData?.messageRepliesEmail,
    messageRepliesPhone: messageModuleData?.messageRepliesPhone,
    reportEmail: messageModuleData?.reportEmail,
    reportPhone: messageModuleData?.reportPhone,
  })
  const [reportsModule, setReportsModule] = useState<any>(reportsModuleData)

  const [updatePageSubscribtion, {isLoading: isLoadingUpdateStatusPageSubscribtion}] =
    useUpdateOwnerStatusPageSubscribeMutation()

  const [update2FASetting] = useUpdate2FASettingMutation()

  // const [messageReplies, setMessageReplies] = useState({
  //   email:false,
  //   phone:false
  // })
  // const [reports,setReports]=useState()

  const [loading1, setLoading1] = useState(false)

  const [messageNotificationError, setMessageNotificationError] = useState<any>()
  const dispatch = useDispatch()

  const status = useSelector(getUserData)

  const [passwordType, setPasswordType] = useState({
    current: true,
    password: true,
    confirm: true,
  })

  useEffect(() => {
    if (!!globalSettingData) {
      setGlobalSettings(globalSettingData ?? [])
    }
  }, [globalSettingData])

  useEffect(() => {
    AuthenticateUser('message-notification-configuration') &&
      dispatch(GetOwnersMessageNotificationSetting())
    AuthenticateUser('message-notification-configuration') &&
      dispatch(GetOwnersReportSetting())
  }, [dispatch])

  useEffect(() => {
    !Array.isArray(messageModuleData) && setMessageModule(messageModuleData)
  }, [
    messageModuleData,
    messageModule?.messageRepliesEmail,
    messageModule?.messageRepliesPhone,
    messageModule?.reportEmail,
    messageModule?.reportPhone,
  ])

  useEffect(() => {
    !Array.isArray(reportsModuleData) && setReportsModule(reportsModuleData)
  }, [reportsModuleData])

  const formik1 = useFormik<any>({
    initialValues: {
      ...emailUpdateData,
    },
    validationSchema: emailFormValidationSchema,
    onSubmit: (values, {resetForm}) => {
      setLoading1(true)
      const data = {
        newEmail: values.newEmail,
        password: values.confirmPassword,
      }
      dispatch(fetchAsyncChangeEmail(data))
      setShowEmailForm(false)
      resetForm()
      if (data) {
        setLoading1(false)
      }
    },
  })

  if (status.status) {
  }

  const [loading2, setLoading2] = useState(false)

  const formik2 = useFormik<any>({
    initialValues: {
      ...passwordUpdateData,
    },
    validationSchema: passwordFormValidationSchema,
    onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {
      setLoading2(true)
      try {
        let data = {
          password: values.newPassword,
          currentpassword: values.currentPassword,
        }
        dispatch(fetchAsyncChangePassword(data))
        setLoading2(false)
        setPasswordForm(false)
        resetForm()
      } catch (error) {
        setStatus('The quick message detail is incorrect')
        setSubmitting(false)
        setLoading2(false)
      }
    },
  })

  const formik3 = useFormik<any>({
    initialValues: {
      statusPage,
      statusPageSubscribtionEmail: '',
    },
    validationSchema: networkChangeValidationSchema,
    onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {
      try {
        const response = await updatePageSubscribtion({
          statusPageSubscribtion: statusPage,
          statusPageSubscribtionEmail: values.statusPageSubscribtionEmail,
        }).unwrap()

        response?.status ? toast?.success(response?.message) : toast?.error(response?.message)
        await dispatch(fetchAsyncUserDetails())

        resetForm()
      } catch (error) {
        setStatus('The quick message detail is incorrect')
      }
    },
  })

  function addOrRemoveFromArray(arr: string[], value: string): string[] {
    let tempData = [...arr]
    if (tempData.includes(value)) {
      // Value exists in the array, so remove it
      tempData = tempData.filter((item) => item !== value)
    } else {
      // Value does not exist in the array, so add it
      tempData.push(value)
    }

    return tempData
  }

  const handleRemoveSetting = () => {
    dispatch(updateOwnersGlobalSetting({globalSetting: globalSettings, user: updateEmailData?._id}))
  }

  useEffect(() => {
    if (isArray(updateEmailData?.statusPageSubscribtion)) {
      setStatusPage(updateEmailData?.statusPageSubscribtion)
    }

    if (updateEmailData?.statusPageSubscribtionEmail) {
      formik3.setFieldValue(
        'statusPageSubscribtionEmail',
        updateEmailData?.statusPageSubscribtionEmail
      )
    } else {
      // Add default user email when subscribtion not set yet
      formik3.setFieldValue('statusPageSubscribtionEmail', updateEmailData?.email)
    }
  }, [updateEmailData?.statusPageSubscribtion, updateEmailData?.statusPageSubscribtionEmail])

  const handleUpdate2FAsetting = async (status: boolean) => {
    const response = await update2FASetting({is2FAEnabled: status}).unwrap()

    response?.status ? toast?.success(response?.message) : toast?.error(response?.message)
    await dispatch(fetchAsyncUserDetails())
  }
  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_signin_method'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0 fs-2'>Sign-in Method</h3>
          </div>
        </div>

        <div id='kt_account_signin_method' className='collapse show'>
          <div className='card-body border-top p-9'>
            <div className='d-flex flex-wrap align-items-center'>
              <div id='kt_signin_email' className={' ' + (showEmailForm && 'd-none')}>
                <div className='fs-6 fw-bolder mb-1'>Email Address</div>
                <div className='fw-bold text-gray-600'>{updateEmailData?.email}</div>
              </div>

              <div
                id='kt_signin_email_edit'
                className={'flex-row-fluid ' + (!showEmailForm && 'd-none')}
              >
                <form
                  autoComplete='off'
                  onSubmit={formik1.handleSubmit}
                  id='kt_signin_change_email'
                  className='form'
                  noValidate
                >
                  <div className='row mb-6'>
                    <div className='col-lg-6 mb-4 mb-lg-0'>
                      <div className='fv-row mb-0'>
                        <label htmlFor='emailaddress' className='form-label fs-6 fw-bolder mb-3'>
                          Enter New Email Address
                        </label>
                        <input
                          autoComplete='new-email'
                          type='email'
                          className='form-control form-control-lg form-control-solid'
                          id='emailaddress'
                          placeholder='Email Address'
                          {...formik1.getFieldProps('newEmail')}
                        />
                        {formik1.touched.newEmail && formik1.errors.newEmail && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>
                              {formik1.errors.newEmail}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='col-lg-6'>
                      <div className='fv-row mb-0'>
                        <label
                          htmlFor='confirmemailpassword'
                          className='form-label fs-6 fw-bolder mb-3'
                        >
                          Confirm Password
                        </label>
                        <input
                          autoComplete='new-password'
                          type='password'
                          className='form-control form-control-lg form-control-solid'
                          id='confirmemailpassword'
                          {...formik1.getFieldProps('confirmPassword')}
                        />
                        {formik1.touched.confirmPassword && formik1.errors.confirmPassword && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>
                              {formik1.errors.confirmPassword}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='d-flex'>
                    <button
                      id='kt_signin_submit'
                      type='submit'
                      className='btn btn-primary  me-2 px-6'
                      data-testid='btnUpdateEmail'
                    >
                      {!loading1 && 'Update Email'}
                      {loading1 && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          Please wait...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                    <button
                      id='kt_signin_cancel'
                      type='button'
                      onClick={() => {
                        setShowEmailForm(false)
                      }}
                      className='btn btn-color-gray-400 btn-active-light-primary px-6'
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>

              <div id='kt_signin_email_button' className={'ms-auto ' + (showEmailForm && 'd-none')}>
                <button
                  onClick={() => {
                    setShowEmailForm(true)
                  }}
                  className='btn btn-light btn-active-light-primary'
                  data-testid='btnChangeEmail'
                >
                  Change Email
                </button>
              </div>
            </div>

            <div className='separator separator-dashed my-6'></div>
            {/* Password */}
            <div className='d-flex flex-wrap align-items-center mb-10'>
              <div id='kt_signin_password' className={'' + (showPasswordForm && 'd-none')}>
                <div className='fs-6 fw-bolder mb-1'>Password</div>
                <div className='fw-bold text-gray-600'>************</div>
              </div>

              <div
                id='kt_signin_password_edit'
                className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}
              >
                <form
                  onSubmit={formik2.handleSubmit}
                  id='kt_signin_change_password'
                  className='form'
                  noValidate
                >
                  <div className='row mb-1'>
                    <div className='col-lg-4'>
                      <div className='fv-row mb-0'>
                        <label htmlFor='currentpassword' className='form-label fs-6 fw-bolder mb-3'>
                          Current Password
                        </label>
                        <div className='password-wrap'>
                          <input
                            type={passwordType.current ? 'password' : 'text'}
                            className='form-control form-control-lg form-control-solid '
                            id='currentpassword'
                            {...formik2.getFieldProps('currentPassword')}
                          />
                          <span
                            className='svg-icon svg-icon-3'
                            onClick={() => {
                              setPasswordType({...passwordType, current: !passwordType.current})
                            }}
                          >
                            {passwordType.current ? (
                              <i className='bi bi-eye-fill'></i>
                            ) : (
                              <i className='bi bi-eye-slash-fill'></i>
                            )}
                          </span>
                        </div>
                        {formik2.touched.currentPassword && formik2.errors.currentPassword && (
                          <div className='fv-plugins-message-container text-danger'>
                            <div className='fv-help-block'>{formik2.errors.currentPassword}</div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='col-lg-4'>
                      <div className='fv-row mb-0'>
                        <label htmlFor='newpassword' className='form-label fs-6 fw-bolder mb-3'>
                          New Password
                        </label>
                        <div className='password-wrap'>
                          <input
                            type={passwordType.password ? 'password' : 'text'}
                            className='form-control form-control-lg form-control-solid '
                            id='newpassword'
                            {...formik2.getFieldProps('newPassword')}
                          />
                          <span
                            className='svg-icon svg-icon-3'
                            onClick={() => {
                              setPasswordType({...passwordType, password: !passwordType.password})
                            }}
                          >
                            {passwordType.password ? (
                              <i className='bi bi-eye-fill'></i>
                            ) : (
                              <i className='bi bi-eye-slash-fill'></i>
                            )}
                          </span>
                        </div>
                        {formik2.touched.newPassword && formik2.errors.newPassword && (
                          <div className='fv-plugins-message-container text-danger'>
                            <div className='fv-help-block'>{formik2.errors.newPassword}</div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='col-lg-4'>
                      <div className='fv-row mb-0'>
                        <label htmlFor='confirmpassword' className='form-label fs-6 fw-bolder mb-3'>
                          Confirm New Password
                        </label>
                        <div className='password-wrap'>
                          <input
                            type={passwordType.confirm ? 'password' : 'text'}
                            className='form-control form-control-lg form-control-solid '
                            id='confirmpassword'
                            {...formik2.getFieldProps('passwordConfirmation')}
                          />
                          <span
                            className='svg-icon svg-icon-3'
                            onClick={() => {
                              setPasswordType({...passwordType, confirm: !passwordType.confirm})
                            }}
                          >
                            {passwordType.confirm ? (
                              <i className='bi bi-eye-fill'></i>
                            ) : (
                              <i className='bi bi-eye-slash-fill'></i>
                            )}
                          </span>
                        </div>
                        {formik2.touched.passwordConfirmation &&
                          formik2.errors.passwordConfirmation && (
                            <div className='fv-plugins-message-container text-danger'>
                              <div className='fv-help-block'>
                                {formik2.errors.passwordConfirmation}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className='form-text mb-5'>
                    Password must be at least 8 character and contain symbols
                  </div>

                  <div className='d-flex'>
                    <button
                      data-testid='btnUpdatePassword'
                      id='kt_password_submit'
                      type='submit'
                      className='btn btn-primary me-2 px-6'
                    >
                      {!loading2 && 'Update Password'}
                      {loading2 && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          Please wait...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                    <button
                      onClick={() => {
                        setPasswordForm(false)
                      }}
                      id='kt_password_cancel'
                      type='button'
                      className='btn btn-color-gray-400 btn-active-light-primary px-6'
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>

              <div
                id='kt_signin_password_button'
                className={'ms-auto ' + (showPasswordForm && 'd-none')}
              >
                <button
                  onClick={() => {
                    setPasswordForm(true)
                  }}
                  className='btn btn-light btn-active-light-primary'
                  data-testid='btnResetPassword'
                >
                  Reset Password
                </button>
              </div>
            </div>

            <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6'>
              <KTSVG
                path='/media/icons/duotune/general/gen048.svg'
                className='svg-icon-2tx svg-icon-primary me-4'
              />
              <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                <div className='mb-3 mb-md-0 fw-bold'>
                  <h4 className='text-gray-800 fw-bolder'>Secure Your Account</h4>
                  <div className='fs-6 text-gray-600 pe-7'>
                    Two-factor authentication adds an extra layer of security to your account. To
                    log in, in addition you'll need to provide a 6 digit code
                  </div>
                </div>
                <button
                  data-testid='btn2FA'
                  className={clsx('btn px-6 align-self-center text-nowrap', {
                    'btn-primary': !updateEmailData.is2FAEnabled,
                    'btn-danger': updateEmailData.is2FAEnabled,
                  })}
                  onClick={() => {
                    handleUpdate2FAsetting(!updateEmailData.is2FAEnabled)
                  }}
                >
                  {updateEmailData.is2FAEnabled ? 'Disable' : 'Enable'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_deactivate'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0 fs-2'>Global Settings</h3>
          </div>
        </div>

        <div id='kt_account_deactivate' className='collapse'>
          <div className='card-body border-top p-9'>
            <div className='row globalSettingBox'>
              <h5
                className='text-gray-600'
                style={{
                  fontSize: '18px',
                  fontWeight: '600',
                }}
              >
                Bulk Reply Stop Optout
              </h5>
              <div
                className='col-6 mt-2'
                style={{
                  display: 'flex',
                  gap: '10px',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Bulk SMS Reply Stop Optout
                </span>
                <ToggleSwitch.Check
                  onChange={() => {
                    setGlobalSettings([
                      ...addOrRemoveFromArray(
                        globalSettings,
                        globalSettingsTypes.BULK_SMS_REPLY_STOP_OUTPUT
                      ),
                    ])
                  }}
                  checked={globalSettings?.includes(globalSettingsTypes.BULK_SMS_REPLY_STOP_OUTPUT)}
                  type='switch'
                  id='custom-switch'
                  className='col-4'
                />
              </div>
              <div className='col-6'>
                <div
                  className='col-6 mt-2'
                  style={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                  }}
                >
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Bulk MMS Reply Stop Optout
                  </span>
                  <ToggleSwitch.Check
                    onChange={() =>
                      setGlobalSettings([
                        ...addOrRemoveFromArray(
                          globalSettings,
                          globalSettingsTypes.BULK_MMS_REPLY_STOP_OUTPUT
                        ),
                      ])
                    }
                    checked={globalSettings?.includes(
                      globalSettingsTypes.BULK_MMS_REPLY_STOP_OUTPUT
                    )}
                    type='switch'
                    id='custom-switch'
                    className='col-4'
                  />
                </div>
              </div>
            </div>

            <div className='row mt-10 globalSettingBox'>
              <h5
                className='text-gray-600'
                style={{
                  fontSize: '18px',
                  fontWeight: '600',
                }}
              >
                Quick Reply Stop Optout
              </h5>
              <div
                className='col-6 mt-2'
                style={{
                  display: 'flex',
                  gap: '10px',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Quick SMS Reply Stop Optout
                </span>
                <ToggleSwitch.Check
                  onChange={() =>
                    setGlobalSettings([
                      ...addOrRemoveFromArray(
                        globalSettings,
                        globalSettingsTypes.QUICK_SMS_REPLY_STOP_OUTPUT
                      ),
                    ])
                  }
                  checked={globalSettings?.includes(
                    globalSettingsTypes.QUICK_SMS_REPLY_STOP_OUTPUT
                  )}
                  type='switch'
                  id='custom-switch'
                  className='col-4'
                />
              </div>
              <div className='col-6'>
                <div
                  className='col-6 mt-2'
                  style={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                  }}
                >
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Quick MMS Reply Stop Optout
                  </span>
                  <ToggleSwitch.Check
                    onChange={() =>
                      setGlobalSettings([
                        ...addOrRemoveFromArray(
                          globalSettings,
                          globalSettingsTypes.QUICK_MMS_REPLY_STOP_OUTPUT
                        ),
                      ])
                    }
                    checked={globalSettings?.includes(
                      globalSettingsTypes.QUICK_MMS_REPLY_STOP_OUTPUT
                    )}
                    type='switch'
                    id='custom-switch'
                    className='col-4'
                  />
                </div>
              </div>
            </div>

            <div className='row mt-10 globalSettingBox'>
              <h5
                className='text-gray-600'
                style={{
                  fontSize: '18px',
                  fontWeight: '600',
                }}
              >
                Message to unsubscribe contacts
              </h5>
              <div
                className='col-6 mt-2'
                style={{
                  display: 'flex',
                  gap: '10px',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Bulk Message
                </span>
                <ToggleSwitch.Check
                  onChange={() =>
                    setGlobalSettings([
                      ...addOrRemoveFromArray(
                        globalSettings,
                        globalSettingsTypes.BULK_MESSAGE_TO_UNSUB_CONTACT
                      ),
                    ])
                  }
                  checked={globalSettings?.includes(
                    globalSettingsTypes.BULK_MESSAGE_TO_UNSUB_CONTACT
                  )}
                  type='switch'
                  id='custom-switch'
                  className='col-4'
                />
              </div>
              <div className='col-6'>
                <div
                  className='col-6 mt-2'
                  style={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                  }}
                >
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Quick Message
                  </span>
                  <ToggleSwitch.Check
                    onChange={() =>
                      setGlobalSettings([
                        ...addOrRemoveFromArray(
                          globalSettings,
                          globalSettingsTypes.QUICK_MESSAGE_TO_UNSUB_CONTACT
                        ),
                      ])
                    }
                    checked={globalSettings?.includes(
                      globalSettingsTypes.QUICK_MESSAGE_TO_UNSUB_CONTACT
                    )}
                    type='switch'
                    id='custom-switch'
                    className='col-4'
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button onClick={handleRemoveSetting} type='submit' className='btn btn-sm btn-primary'>
              Save Changes
            </button>
          </div>
        </div>
      </div> */}

      {/* Status Page Subscription */}
      {AuthenticateUser('message-notification-configuration') && (
        <div className='card mb-5 mb-xl-10'>
          <div
            className='card-header border-0 cursor-pointer'
            role='button'
            data-bs-toggle='collapse'
            data-bs-target='#kt_account_status_page'
          >
            <div className='card-title m-0'>
              <h3 className='fw-bolder m-0 fs-2'>Network Status Alerts</h3>
            </div>
          </div>

          <div id='kt_account_status_page'>
            <form
              autoComplete='off'
              onSubmit={formik3.handleSubmit}
              id='kt_signin_change_email'
              className='form'
              noValidate
            >
              <div className='card-body border-top p-9 d-grid gap-2'>
                <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6 mb-8'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen044.svg'
                    className='svg-icon-2tx svg-icon-primary me-4'
                  />
                  <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                    <div className='mb-3 mb-md-0 fw-bold'>
                      <div className='fs-6 text-gray-600 pe-7'>
                        You can subscribe to receive notifications from our{' '}
                        <a href='https://status.cellcast.com' target='_blank' rel="noreferrer">
                          Status Page
                        </a>{' '}
                        By opting in, you'll get email updates whenever there are changes to the
                        system status, including any downtimes.
                      </div>
                    </div>
                  </div>
                </div>

                <label htmlFor='emailaddress' className='form-label fs-6 fw-bolder mb-3'>
                  Network Status
                </label>

                {['SMS - AU', 'MMS - AU', 'SMPP API', 'REST API', 'Cellcast App'].map((it) => (
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input me-5'
                      id='network-status'
                      type='checkbox'
                      data-kt-check='true'
                      checked={statusPage?.includes(it)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setStatusPage([...statusPage, it])
                        } else {
                          setStatusPage(statusPage.filter((stats) => stats != it))
                        }
                      }}
                    />
                    <div>
                      <label htmlFor='stagger' className='text-muted'>
                        {it}
                      </label>
                    </div>
                  </div>
                ))}

                <div className='fv-row mb-0'>
                  <label htmlFor='emailaddress' className='form-label fs-6 fw-bolder mb-3 mt-3'>
                    Email Address
                  </label>
                  <input
                    type='email'
                    className='form-control form-control-lg form-control-solid'
                    id='statusPageSubscribtionEmail'
                    placeholder='Email Address separate by ; for multiple emails'
                    {...formik3.getFieldProps('statusPageSubscribtionEmail')}
                  />

                  {formik3.touched.statusPageSubscribtionEmail &&
                    formik3.errors.statusPageSubscribtionEmail && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger'>
                          {formik3.errors.statusPageSubscribtionEmail}
                        </div>
                      </div>
                    )}
                </div>
              </div>

              <div className='card-footer d-flex justify-content-end py-6 px-9'>
                <button
                  data-testid='btnSaveChangesNetworkStatusAllerts'
                  type='submit'
                  className='btn btn-sm btn-primary'
                  disabled={!formik3?.isValid || isLoadingUpdateStatusPageSubscribtion}
                >
                  {isLoadingUpdateStatusPageSubscribtion ? <Spinner /> : 'Save Changes'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Message Notification */}
      {AuthenticateUser('message-notification-configuration') && (
       <div>
          <MessageNotificationModule messageNotification={messageModule} />
          <ReportsNotificationModule reportsNotification={reportsModule} />
          <SoundNotification />
          <OptOutFraudKeyword />
       </div>
      )}

      {/* Deactivate Account */}
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_deactivate'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0 fs-2'>Deactivate Account</h3>
          </div>
        </div>

        <div id='kt_account_deactivate'>
          <div className='card-body border-top p-9'>
            <div className='notice d-flex bg-light-danger rounded border-warning border border-dashed p-6 deactivate-account mb-8'>
              <KTSVG
                path='/media/icons/duotune/general/gen044.svg'
                className='svg-icon-2tx svg-icon-primary me-4'
              />
              <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                <div className='mb-3 mb-md-0 fw-bold'>
                  <h4 className='text-gray-800 fw-bolder'>You Are Deactivating Your Account</h4>
                  <div className='fs-6 text-gray-600 pe-7'>
                    For extra security, this requires you to confirm your email or phone number when
                    you reset your sign password.
                  </div>
                  <a href='#'>Learn more</a>
                </div>
              </div>
            </div>
            <div className='form-check form-check-sm form-check-custom form-check-solid'>
              <input
                className='form-check-input me-5'
                id='stagger'
                type='checkbox'
                data-kt-check='true'
                // checked={bulkMessageData.staggerMessages}
              />
              <div>
                <label htmlFor='stagger' className='text-muted'>
                  I confirm my account deactivation
                </label>
              </div>
            </div>
          </div>

          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button type='submit' className='btn btn-sm btn-danger'>
              Deactivate Account
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default FrontendSigninMethod
